import { atom } from 'jotai'

export const loanDetailsModalAtom = atom(false)
